export default "__VITE_ASSET__P_Py069Y__"